import { Help, Spacing, Text } from 'zens-storybook'
import React, { PropsWithChildren, ReactElement } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

const styles = StyleSheet.create({
  container: {},
  head: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: Spacing.M,
    zIndex: 200,
  },
  right: {
    flex: 1,
    alignItems: 'flex-end',
  },
})

interface Props extends ViewProps {
  title?: string | ReactElement
  right?: ReactElement | false
  help?: string | ReactElement
}
const Panel = (props: Props) => {
  const { title, right, help, style, children, ...otherProps } = props

  const titleView = <Text level={4}>{title}</Text>

  const rightView = right ? <View style={styles.right}>{right}</View> : undefined
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {(title || right || help) && (
        <View style={styles.head}>
          {help ? (
            <Help message={help} right={rightView}>
              {titleView}
            </Help>
          ) : (
            <>
              {titleView}
              {rightView}
            </>
          )}
        </View>
      )}
      {children}
    </View>
  )
}

export interface SkeletonProps extends ViewProps {
  title?: string | true
  right?: ReactElement | false
  contentStyle?: StyleProp<ViewStyle>
}

Panel.Skeleton = (props: PropsWithChildren<SkeletonProps>) => {
  const { title, right, contentStyle, style, children, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {title === true ? (
        <Text.Skeleton style={[styles.head, contentStyle]} width={200} level={4} />
      ) : (
        title && (
          <View style={[styles.head, contentStyle]}>
            <Text level={4}>{title}</Text>
            {right && <View style={styles.right}>{right}</View>}
          </View>
        )
      )}
      {children}
    </View>
  )
}
export default Panel
